module.exports = __webpack_public_path__ + "static/teamlab-824d02fe27fb933d11cbb947665c4e50.png";